<ng-container [ngSwitch]="contentEnumVal">
    <ng-container *ngSwitchCase="'Product Cell'">
        <!-- <div class="cell-content-layer">
            <div class="product-grid cell-shadow" [ngClass]="cell.layoutClass?cell.layoutClass:'cell-layout-default'">
                <ng-container [ngSwitch]="cell?.layoutClass">
                    <ng-container *ngSwitchCase="'cell-layout-1'">
                        <div class="product-content header product-header">
                            <div class="product-name">
                                <kw-content-element-renderer contentName="Product Name" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                            </div>
                            <div class="product-promo">
                                <div class="product-discount">
                                    <kw-content-element-renderer contentName="Discount" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-release">
                                    <kw-content-element-renderer contentName="Release" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                        </div>
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{cell?.imgSrc}}">
                                <img class="pic-2" src="{{cell?.imgSrc}}">
                            </a>
                            
                            <ul class="element-container action-elements product-links">
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="product-content footer">
                            <div class="product-price-details">
                                <div class="product-list-price">
                                    <kw-content-element-renderer contentName="Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-end" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-default-price">
                                    <kw-content-element-renderer contentName="Normal Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-start" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                            <div class="procuct-actions">
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                            </div>
                            <div class="product-identification">
                                <div class="product-category">
                                    <kw-content-element-renderer contentName="Category" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [class.justify-center]="!hasProductId" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <ng-container *ngIf="hasProductId">
                                    <div class="product-id">
                                        <kw-content-element-renderer contentName="Product Id" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </div>
                                </ng-container>
                            </div>
                        </div> 
                    </ng-container>
                    <ng-container *ngSwitchCase="'cell-layout-2'">
                        <div class="product-content header product-header">
                            <div class="product-name">
                                <kw-content-element-renderer contentName="Product Name" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                            </div>
                            <div class="product-promo">
                                <div class="product-discount">
                                    <kw-content-element-renderer contentName="Discount" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-release">
                                    <kw-content-element-renderer contentName="Release" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                        </div>
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{cell?.imgSrc}}">
                                <img class="pic-2" src="{{cell?.imgSrc}}">
                            </a>
                            
                            <ul class="element-container action-elements product-links">
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="product-content footer">
                            <div class="product-price-details">
                                <div class="product-list-price">
                                    <kw-content-element-renderer contentName="Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-end" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-default-price">
                                    <kw-content-element-renderer contentName="Normal Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-start" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                            <div class="procuct-actions">
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                            </div>
                            <div class="product-identification">
                                <div class="product-category">
                                    <kw-content-element-renderer contentName="Category" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [class.justify-center]="!hasProductId" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <ng-container *ngIf="hasProductId">
                                    <div class="product-id">
                                        <kw-content-element-renderer contentName="Product Id" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </div>
                                </ng-container>
                            </div>
                        </div> 
                    </ng-container>
                    
                    <ng-container *ngSwitchCase="'cell-layout-3'">
                        <div class="product-content header">
                            <div class="product-price-details">
                                <div class="product-list-price">
                                    <kw-content-element-renderer contentName="Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-end" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-default-price">
                                    <kw-content-element-renderer contentName="Normal Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-start" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                        </div>
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{cell?.imgSrc}}">
                                <img class="pic-2" src="{{cell?.imgSrc}}">
                            </a>
                            
                            <ul class="element-container action-elements product-links">
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="product-content footer">
                            <div class="product-content header">
                                <kw-content-element-renderer contentName="Product Name" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                            </div>
                            <div class="procuct-actions">
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="product-image">
                            <a href="#" class="image">
                                <img class="pic-1" src="{{cell?.imgSrc}}">
                                <img class="pic-2" src="{{cell?.imgSrc}}">
                            </a>
                            <ul class="element-container action-elements product-links">
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="product-content footer">
                            <div class="header-in-footer">
                                <div class="product-name">
                                    <kw-content-element-renderer contentName="Product Name" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-promo">
                                    <div class="product-discount">
                                        <kw-content-element-renderer contentName="Discount" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </div>
                                    <div class="product-release">
                                        <kw-content-element-renderer contentName="Release" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </div>
                                </div>
                            </div>
                            <div class="product-price-details">
                                <div class="product-list-price">
                                    <kw-content-element-renderer contentName="Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-end" [preview]="false"></kw-content-element-renderer>
                                </div>
                                <div class="product-default-price">
                                    <kw-content-element-renderer contentName="Normal Price" [contentElements]="cell?.contentElements" class="kw-content-element-renderer group-start" [preview]="false"></kw-content-element-renderer>
                                </div>
                            </div>
                            <div class="procuct-actions">
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Cart" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Add To Wish List" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                                <div class="procuct-actions-icon">
                                    <a href="#">
                                        <kw-content-element-renderer contentName="Quick View" [contentElements]="cell?.contentElements" class="kw-content-element-renderer" [preview]="false"></kw-content-element-renderer>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                
            </div>
        </div> -->
        <kve-product-cell-content [cell]="cell"></kve-product-cell-content>
    </ng-container>
    <ng-container *ngSwitchCase="'Feature'">
        <kve-feature-cell-content [cell]="cell"></kve-feature-cell-content>
    </ng-container>
</ng-container>

